var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"dashboard-header"},[(
      this.title === 'Pages'
      || this.title === 'Components'
      || this.window.location.pathname.includes('/applications/')
      || this.$route.name === 'tip'
      || this.$route.name === 'momentstrategy'
      || this.$route.name === 'sections'
      || this.$route.name === 'questions'
      || this.$route.name === 'options'
    )?_c('div',{staticClass:"back-button",on:{"click":_vm.handleBackButton}},[_c('BackButtonIcon')],1):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.title))]),(_vm.hideApplicationSelection())?_c('p',{staticClass:"select-application"},[_vm._v("\n    Select application:\n  ")]):_vm._e(),(_vm.hideApplicationSelection())?_c('Dropdown',{attrs:{"title":_vm.selectedApplicationName}},[_c('DropdownSearch',{attrs:{"list":_vm.applications}})],1):_vm._e(),_c('div',{staticClass:"header--menu",on:{"click":function($event){return _vm.$emit('handleNavigation')}}},[_c('MenuIcon')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }